import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useStyles } from '../style'
import { OutlinedButton } from '../../../elements'
import { Grid, TextField, MenuItem, Box } from '@material-ui/core'
import { useFormik } from 'formik'
import _ from 'lodash'
import * as yup from 'yup'
import { DisplayMessage, Loader } from '../../../Components'
import * as messageTypes from '../../../utils/messageTypes'
import { reportService } from '../../../Services/ReportService/ReportService'
import { eventService } from '../../../Services'
import moment from 'moment'
import { pushToDataLayer, USERBEHAVIOURTRACKING } from '../../../utils/gaEnvironment'

const validationSchema = yup.object({
  account: yup
    .string('Select account name')
    .required('Account name is required'),
  program: yup
    .string('Select program name')
    .required('Program name is required'),
  eventId: yup
    .string('Enter Event Id')
    .required('Event Id is required'),
})

function EventTelemetryReport(props) {
  const classes = useStyles()
  const [programs, setPrograms] = useState((props.isSuperAdmin || props.isViewOnly) ? props.programs : props.programs.filter(program => program.feature_flags && program.feature_flags.program_and_events))
  const [events, setEvents] = useState([])
  const [open, setOpen] = useState()
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState()

  const { currentUser } = props

  const formik = useFormik({
    initialValues: {
      account: (props.isSuperAdmin || props.isViewOnly) ? '' : currentUser && currentUser.account_id,
      program: '',
      eventId: ''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      pushToDataLayer({ event: USERBEHAVIOURTRACKING, accountID: currentUser.account_id, programID: values.program, siteID: values.site })
      getReport(values)
    },
  })

  const getReport = (values) => {
    const { currentUser } = props
    setLoading(true)
    reportService.getEventTelemetryReport(currentUser, values)
      .then(reportData => {
        setLoading(false)
        setOpen(true)
        if (values.report_type === 'PDF') {
          let popUp = window.open(reportData, '_blank', '')
          if (popUp == null || typeof (popUp) == 'undefined') {
            setMessage('Please disable your pop-up blocker and download file again.')
            setMessageType(messageTypes.INFO)
          }
          else {
            setMessage('Report downloading')
            setMessageType(messageTypes.SUCCESS)
          }
        } else {
          downloadFile(reportData, values)
          setMessage('Report downloading')
          setMessageType(messageTypes.SUCCESS)
        }
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const downloadFile = (fileUrl, values) => {
    const a = document.createElement("a")
    a.href = fileUrl
    a.target = values.report_type === 'PDF' ? "_blank" : ''
    a.setAttribute("download", `EventTelemetryReport_${new Date()}.${formik.values.report_type.toLowerCase()}`)
    a.click()
  }

  const handleAccountChange = (e) => {
    formik.setFieldValue([e.target.name], e.target.value)
    formik.setFieldValue('program', '')
    formik.setFieldValue('eventId', '')
    setPrograms(props.programs.filter(program => (props.isSuperAdmin || props.isViewOnly) ? program.account_id === e.target.value : program.account_id === e.target.value && program.feature_flags && program.feature_flags.program_and_events))
  }

  const handleProgramChange = (e) => {
    formik.setFieldValue([e.target.name], e.target.value)
    formik.setFieldValue('eventId', '')
    eventService.getAllEventsByProgramId(e.target.value, currentUser.account_id)
      .then(eventData => {
        setEvents(eventData)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  useEffect(() => {
    formik.resetForm()
  }, [props.name])

  return (
    <>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <div className={classes.formHeading}>Event Telemetry Report</div>
      <div className={classes.formSubHeading}>Please enter the details below to download the report.</div>
      <form onSubmit={formik.handleSubmit}>
        <Box my={5}>
          <Grid container>
            <Grid item xs={12}>
              <Box display={(props.isSuperAdmin || props.isViewOnly) ? '' : 'none'}>
                <TextField
                  label="Account Name"
                  select
                  name="account"
                  fullWidth
                  value={formik.values.account}
                  disabled={!(props.isSuperAdmin || props.isViewOnly)}
                  style={{ maxWidth: 500 }}
                  onChange={handleAccountChange}
                  InputProps={{
                    classes: { root: classes.input }
                  }}
                  SelectProps={{
                    MenuProps: {
                      classes: { paper: classes.paper },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }
                  }}
                  error={formik.touched.account && Boolean(formik.errors.account)}
                  helperText={formik.touched.account && formik.errors.account}
                >
                  {(props.isSuperAdmin || props.isViewOnly) ? props.accounts.map(account => (
                    <MenuItem value={_.get(account, 'id', '')}>{_.get(account, 'company_name', 'NA')}</MenuItem>
                  )) :
                    <MenuItem value={currentUser.account_id}>{currentUser.account_company_name}</MenuItem>
                  }
                </TextField>
              </Box>
            </Grid>
            <Grid xs={12}>
              <TextField
                label="Program Name"
                select
                name="program"
                fullWidth
                value={formik.values.program}
                disabled={!formik.values.account}
                style={{ maxWidth: 500 }}
                onChange={handleProgramChange}
                InputProps={{
                  classes: { root: classes.input }
                }}
                SelectProps={{
                  MenuProps: {
                    classes: { paper: classes.paper },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }
                }}
                error={formik.touched.program && Boolean(formik.errors.program)}
                helperText={formik.touched.program && formik.errors.program}
              >
                {programs.length > 0 ? programs.map(program => (
                  <MenuItem value={program.id}>{program.program_name_admin_ui}</MenuItem>
                )) :
                  <MenuItem value="noProgramFound" disabled>No Program Found</MenuItem>
                }
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Event Id"
                select
                name="eventId"
                fullWidth
                value={formik.values.eventId}
                disabled={!formik.values.program}
                style={{ maxWidth: 500 }}
                onChange={formik.handleChange}
                InputProps={{
                  classes: { root: classes.input }
                }}
                SelectProps={{
                  MenuProps: {
                    classes: { paper: classes.paper },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }
                }}
                error={formik.touched.eventId && Boolean(formik.errors.eventId)}
                helperText={formik.touched.eventId && formik.errors.eventId}
              >
                {events.length > 0 ? events.map(event => (
                  <MenuItem value={event.id}>{`${event.name} ${event.start_date_time ? moment(event.start_date_time).format('- DD MMMM YYYY') : ''}`}</MenuItem>
                )) :
                  <MenuItem value="noEventFound" disabled>No Event Found</MenuItem>
                }
              </TextField>
            </Grid>
          </Grid>
        </Box>
        <div>
          <span className={classes.mr2} ><OutlinedButton type="submit" label="Download CSV" onClick={() => { formik.setFieldValue('report_type', 'CSV') }} /></span>
          <span className={classes.mr2} ><OutlinedButton type="submit" label="Download PDF" onClick={() => { formik.setFieldValue('report_type', 'PDF') }} /></span>
        </div>
      </form>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isViewOnly, timezone } = auth
  return { currentUser, isSuperAdmin, isViewOnly, timezone }
}

export default connect(mapStateToProps, {})(EventTelemetryReport)